"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatValue = void 0;
const vue_1 = require("vue");
let id = 1;
class FloatValue {
    constructor(initOption, show = true) {
        this.id = id++;
        this.type = initOption.type;
        this.name = initOption.name;
        this.autoModal = initOption.autoModal;
        this.props = initOption.props;
        this.event = initOption.event;
        this.component = initOption.component;
        this.show = show;
        this.init = false;
    }
    destroy() {
        //
    }
}
exports.FloatValue = FloatValue;
const floatData = (0, vue_1.reactive)({
    list: [],
    push(valueInitOption) {
        this.list.push(new FloatValue(valueInitOption));
    },
    remove(item) {
        const index = this.list.indexOf(item);
        this.list.splice(index, 1);
        return index;
    },
    replace(item, newInitOption, show) {
        const newItem = new FloatValue(Object.assign(Object.assign({}, item), newInitOption), show);
        const index = this.list.indexOf(item);
        this.list.splice(index, 1, newItem);
    }
});
exports.default = floatData;
